module.exports = __webpack_public_path__ + "static/media/ic-warning.d590afd4.svg";